import { createApp } from 'vue'
import Cacheclear from './Cacheclear.vue';
import {mapLocalizationData} from '../../../common/vue/helper/LocalizationMapper'

document.addEventListener('DOMContentLoaded', () =>{
    let rootId = 'cacheclear';
    let rootElement = document.getElementById(rootId);
    if (rootElement) {

        let app = createApp(Cacheclear, {
                        cacheClearUrl: rootElement.getAttribute('data-cache-clear-url'),
                        elementsJson: decodeURI(rootElement.getAttribute('data-elements-json')),
                        groupsJson: decodeURI(rootElement.getAttribute('data-groups-json')),
                        csrfToken: rootElement.getAttribute('data-csrf-token'),
                        i18n: mapLocalizationData(rootElement),
                    });
        app.mount(rootElement);
    }
});
